import { FaRegCopyright } from "react-icons/fa";
import '../../styles/Copyright.css';

export function Copyright({ copyright }) {
  const today = new Date();
  const year = today.getFullYear();
  const text = copyright.text.replace('ANIO', year);
  return(
    <div className="copyright-container">
      <p className="is-size-6">
        <FaRegCopyright />&nbsp;
        {text}
      </p>
    </div>
  );
}